var map = {
	"./academy.jpg": 1275,
	"./ace-hardware.jpg": 1276,
	"./acklands-grainger.jpg": 1277,
	"./amazon-uk.png": 1278,
	"./amazon.jpg": 1279,
	"./amazonCA.jpg": 1280,
	"./basics.jpg": 1281,
	"./bjs.jpg": 1282,
	"./cabelas.jpg": 1283,
	"./costco-uk.png": 1284,
	"./costco.jpg": 1285,
	"./de-raat.jpg": 1286,
	"./ferrimax.png": 1287,
	"./home-depot.jpg": 1288,
	"./home-hardware.jpg": 1289,
	"./lowes.jpg": 1290,
	"./ncr-angola.jpg": 1291,
	"./officedepot-officemax.jpg": 1292,
	"./officemax-grand-and-toy.jpg": 1293,
	"./powered-by-hatch.svg": 320,
	"./sams-club.jpg": 1294,
	"./staples.jpg": 1295,
	"./tmall.jpg": 1296,
	"./walmart.jpg": 1297
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1308;



//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy ^\.\/.*$
// module id = 1308
// module chunks = 0